import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Button, Form } from '_zari/core'

import * as CompaniaService from 'services/compania.service'

import * as FormGroups from './formGroups'

const EstructurasModal = ({ show, handleClose, refreshEstructuras }) => {
  const __zariContext = React.useContext(ZariContext)

  const mainFormikRef = React.useRef()

  React.useEffect(() => {
    CompaniaService.getEstructuras()
      .then(({ data }) => {
        if (data) {
          setTimeout(() => {
            mainFormikRef.current.setValues({
              tamanoEstructuraNivel1: data.tamanoEstructuraNivel1 || '',
              tamanoEstructuraNivel2: data.tamanoEstructuraNivel2 || ''
            })
          }, 250)
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  const formInitialValues = React.useMemo(() => {
    return {
      tamanoEstructuraNivel1: '',
      tamanoEstructuraNivel2: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      const newData = {
        tamanoEstructuraNivel1: data.tamanoEstructuraNivel1 ? parseFloat(data.tamanoEstructuraNivel1) : null,
        tamanoEstructuraNivel2: data.tamanoEstructuraNivel2 ? parseFloat(data.tamanoEstructuraNivel2) : null
      }

      CompaniaService.actualizarEstructuras(newData)
        .then(() => {
          __zariContext.snack('success', 'Se han actualizado las estructuras.')
          refreshEstructuras()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, handleClose, refreshEstructuras]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>ESTRUCTURAS</Modal.Title>
      </Modal.Header>
      <Formik innerRef={mainFormikRef} initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <Form>
            <Modal.Body>
              <FormGroups.TamanoEstructuraFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.tamanoEstructuraNivel1}
                iTouched={touched.tamanoEstructuraNivel1}
                label='ESTRUCTURA 1'
                name='tamanoEstructuraNivel1'
              />
              <FormGroups.TamanoEstructuraFormGroup
                fIsSubmitting={isSubmitting}
                iError={errors.tamanoEstructuraNivel2}
                iTouched={touched.tamanoEstructuraNivel2}
                label='ESTRUCTURA 2'
                name='tamanoEstructuraNivel2'
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Guardar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(EstructurasModal)
